<script setup lang="ts">

const props = defineProps<{
  success: boolean
  successTitle: string
  successMessage: string
  errorTitle: string
  errorMessage: string
  image?: string
}>()

const emits = defineEmits<{
  (e: "reset"): void;
}>()

</script>

<template>
  <div class="sportmatch-widget-panel-boeken-result">
    <img v-if="image && success" class="sportmatch-widget-panel-boeken-result-image" :src="image" alt="">
    <div class="sportmatch-widget-panel-boeken-result-content">
      <div class="sportmatch-widget-panel-boeken-result-content-wrapper">
        <span class="sportmatch-widget-panel-boeken-result-icon" :class="success ? 'icon-check' : 'icon-close'" aria-hidden="true" />
        <h2 class="sportmatch-widget-panel-boeken-result-title h3"> {{ success ? successTitle : errorTitle }}</h2>
      </div>
      <p>{{ success ? successMessage : errorMessage }}</p>
      <button v-if="!success" class="btn btn-secondary" @click="emits('reset')">Opnieuw proberen</button>
    </div>
  </div>
</template>